<template>
  <div class="notfound-container d-flex flex-shrink-0 flex-column h-100">
    <section class="m-auto container">
      <div class="col-md-12 text-white">
        <h4 class="">Confirm your upgrade to Watch Now</h4>
        <div class="pricetab">
          <table class="table table-borderless table-sm text-white">
            <div class="plan-heading">
              <tr>
                <td class="plan">CURRENT PLAN:Awoof</td>
                <td>₦2000 / Month</td>
              </tr>
              <tr>
                <td class="plan-description">
                  Watch on 2 screens at a time. Download videos on 2 devices for
                  a month
                </td>
              </tr>
            </div>
            <div class="plan-heading">
              <tr>
                <td>New PLAN:Add-on</td>
                <td>+ ₦1000 / Month</td>
              </tr>
              <tr>
                <td class="plan-description">
                  Watch on 5 screens at a time. Download videos on 5 devices for
                  a month.
                </td>
                <td class="sm1">You won’t be charged until 11/08/2020</td>
              </tr>
            </div>
          </table>
        </div>
        <a href="/#/" class="btn btn-primary btn-lg">Upgrade and watch Now </a>
        <a href="/#/" class="btn btn-light btn-lg ml-2">Cancel</a>
      </div>
    </section>
  </div>
</template>

<style scoped>
.plan-heading {
  margin-top: 5px !important;
  padding-top: 25px !important;
  padding-bottom: 20px !important ;
}
.pricetab {
  padding-bottom: 28px !important;
  margin-bottom: 20px;
  padding-top: 20px !important ;
}

.plan-description {
  width: 78.5%;
}

.plan {
  width: 84.5%;
}

.sm1 {
  font-size: 10px;
}
</style>

<script>
export default {
  name: "Subscription",
  components: {},
  computed: {},
};
</script>
